// extracted by mini-css-extract-plugin
export default {"wrapper":"M_CapsuleCommentMobilePreview_wrapper__oFRC4","text":"M_CapsuleCommentMobilePreview_text__TprXw","expand_button":"M_CapsuleCommentMobilePreview_expand_button__NY9JM"};